import { Flex } from "@radix-ui/themes";
import { t } from "i18next";
import React, { ReactNode, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../hooks/useFetch";
import { Button } from "../../../ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "../../../ui/Dialog";
import { Input } from "../../../ui/Input/Input";

type Props = {
  children: ReactNode;
};

function ChangePasswordModal({ children }: Props) {
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      old_password: "",
      new_password: "",
    },
  });

  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/users/account/update_password`, true);
  
    useEffect(() => {
      if (itemSaveResponse) {
        reset();
      }
    }, [itemSaveResponse]);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "PUT",
      data: {
        data: {
          old_password: formData.old_password,
          password: formData.new_password,
        },
      },
    });
  };

  return (
    <Dialog>
      <DialogTrigger asChild={true}>{children}</DialogTrigger>

      <DialogContent style={{ maxWidth: 450 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>{t("change_password")}</DialogTitle>
          <DialogDescription>{t("change_password_text")}</DialogDescription>

          <div className="flex flex-col w-full pt-8 h-full gap-3">
            <Controller
              name="old_password"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input type="password" {...field} label={`${t("old_password")}*`} />
                </div>
              )}
            />

            <Controller
              name="new_password"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input type="password" {...field} label={`${t("new_password")}*`} />
                </div>
              )}
            />

            <div>
              <Button type="button" onClick={handleSubmit(onSubmit)}>
                {t("save")}
              </Button>
              <DialogClose>
                <Button variant="secondary">{t("cancel")}</Button>
              </DialogClose>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default ChangePasswordModal;
